import { getTestIds } from '../../utils/TestIds';
export const GetProgressBarTID = (parentTestId)=>getTestIds(parentTestId);
